import React, { useEffect, useRef, useState } from "react"

import useIsIntersecting from "@/hooks/is-intersecting"

const LazyVideo = ({
  video,
  type = "video/mp4",
  className = "",
  alt,
  width,
  height,
  loop = false,
}) => {
  const videoRef = useRef(null)

  const isIntersecting = useIsIntersecting(videoRef, {
    rootMargin: "0px",
    threshold: [0.6, 1],
  })

  const [hasPlayedVideo, setHasPlayedVideo] = useState(false)

  useEffect(() => {
    const shouldPlayVideo = loop || !hasPlayedVideo

    if (isIntersecting && shouldPlayVideo) {
      videoRef.current.play()
      setHasPlayedVideo(true)
    }
  }, [isIntersecting])

  return (
    <>
      <video
        className={`lazy-video ${className}`}
        playsInline
        muted
        loop={loop}
        disableRemotePlayback
        ref={videoRef}
        width={width}
        height={height}
      >
        <source src={video} type={type} />
      </video>

      {alt && <p className="screen-reader-only">{alt}</p>}
    </>
  )
}
export default LazyVideo
